// extracted by mini-css-extract-plugin
module.exports = {"bar":"c9dUssx","b2b":"molBzC","peg":"hETgAJ"};